import { State } from '../cases/types';
import { ACTION_TYPES, SUBPAGES, TSubPages } from './types';

const exportFunc = (state: State, action: any) => {
  return {
    [ACTION_TYPES.UPDATE_SUBPAGE_DIRTY.toString()]: () => {
      return {
        ...state,
        subPages: {
          ...state.subPages,
          [action.payload.subPage]: {
            ...state.subPages[action.payload.subPage as keyof TSubPages],
            isDirty: action.payload.isDirty,
          },
        },
      };
    },
    [ACTION_TYPES.UPDATE_APPLICANT_SUBPAGE_DIRTY.toString()]: () => {
      return {
        ...state,
        subPages: {
          ...state.subPages,
          [SUBPAGES.APPLICANTS]: state.subPages[SUBPAGES.APPLICANTS].map((applicant, key) => {
            if (action.payload.applicantIndex === key) {
              return {
                ...applicant,
                [action.payload.subPage]: {
                  ...applicant[action.payload.subPage as keyof TSubPages['APPLICANTS'][0]],
                  isDirty: action.payload.isDirty,
                },
              };
            }
            return { ...applicant };
          }),
        },
      };
    },
  };
};

export default exportFunc;
